// extracted by mini-css-extract-plugin
export default {"main":"Main_main__5039W","header-wrapper":"Main_header-wrapper__FNqmS","scheduler-wrapper":"Main_scheduler-wrapper__2OL91"};